import { render, staticRenderFns } from "./performanceStatistics.vue?vue&type=template&id=476d7dd6&scoped=true"
import script from "./performanceStatistics.vue?vue&type=script&lang=js"
export * from "./performanceStatistics.vue?vue&type=script&lang=js"
import style0 from "./performanceStatistics.vue?vue&type=style&index=0&id=476d7dd6&prod&lang=less&scoped=true"
import style1 from "./performanceStatistics.vue?vue&type=style&index=1&id=476d7dd6&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476d7dd6",
  null
  
)

export default component.exports